import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { getModifiedAppointmentsRes } from "../../DashboardAppointmentsView/DashboardAppointmentsViewApiHandler";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export const getMyPatientsAppointments = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    let modifiedRes = getModifiedAppointmentsRes(res?.data?.data);
    if (modifiedRes) {
      res.data.data = modifiedRes;
    }
    return [modifiedRes ? res.data : modifiedRes, false];
  }
  return [null, true]; // [response, error]
};

export const getProcedureForConsultationFilter = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  let modifiedResponse = [];
  if (res?.data?.procedures?.length > 0) {
    res.data.procedures.forEach((data) => {
      let procedure = modifiedResponse.find((ele) => ele.value === data);
      if (!procedure?.value) {
        let obj = {};
        obj["name"] =
          data.charAt(0).toUpperCase() + data.substr(1).toLowerCase();
        obj["value"] = data;
        obj["type"] = "procedure";
        obj["selected"] = false;
        modifiedResponse.push(obj);
      }
    });
  }
  if (res?.data?.tests?.length > 0) {
    res.data.tests.forEach((data) => {
      let procedure = modifiedResponse.find((ele) => ele.value === data);
      if (!procedure?.value) {
        let obj = {};
        obj["name"] =
          data.charAt(0).toUpperCase() + data.substr(1).toLowerCase();
        obj["value"] = data;
        obj["type"] = "procedure";
        obj["selected"] = false;
        modifiedResponse.push(obj);
      }
    });
  }
  modifiedResponse &&
    modifiedResponse.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  return [modifiedResponse, false];
};
